<template>
  <homepage-collections-form />
</template>

<script>
import HomepageCollectionsForm from '@/components/forms/HomepageCollectionsForm'
export default {
  components: {
    HomepageCollectionsForm
  }
}
</script>
